var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpiryDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8725 2.7309H21.6289V0.243652H19.1417V2.7309H6.70543V0.243652H4.21818V2.7309H2.97455C1.60657 2.7309 0.487305 3.85016 0.487305 5.21815V25.1161C0.487305 26.4841 1.60657 27.6034 2.97455 27.6034H22.8725C24.2405 27.6034 25.3598 26.4841 25.3598 25.1161V5.21815C25.3598 3.85016 24.2405 2.7309 22.8725 2.7309ZM22.8725 25.1161H2.97455V11.4363H22.8725V25.1161ZM22.8725 8.94902H2.97455V5.21815H22.8725V8.94902Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiryDate);
export default __webpack_public_path__ + "static/media/expiry_date.03cc7a3d136cb06c444eff16338f00b3.svg";
export { ForwardRef as ReactComponent };